// @ts-nocheck
import styled from 'styled-components';
import colors from '../../../styles/colors';
import GenericRenderContainerSection from './GenericRenderContainerSection';
import { TopDecorColor } from '../../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';
import { useNavigate } from 'react-router-dom';

const ContainerNemiciAmici = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: ${colors.bgColorBlack2};
    border-radius: 8px;

    & h1, h2, h3, h4, h5, h6 {
        margin: 0;
        font-size: 6px;
        text-align: center;
        color: white;
    }
`;

const ContainerSingleChallengerInfo = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;
    padding: 20px 0 10px 0;
    background-color: ${colors.bgColorBordeaux};
    color: white;
    border-radius: 8px;
    border: 3px solid white;
    overflow: hidden;
    margin: 15px 0;
`;

const BoxAvatarNameChallenger = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    & img.avatar-challenger {
        width: 50px;
        height: 50px;
        object-fit: cover;
        object-position: top;
        margin: 10px 0;
    }

    & h2.name-challenger {
        font-size: 12px;
        text-align: center;
        color: white;
        font-weight: 600;
    }

`;

const ContainerListMatchOpponent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
    gap: 5px;
    padding: 0 10px;
`;

const SingleBoxMatchInOpponent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    width: calc(33.3% - 5px);

    & img.avatar-match {
        width: 15px;
        height: 15px;
        object-fit: cover;
        object-position: top;
    }

    & h6.name-match {
        font-size: 6px;
        text-align: center;
        color: white;
        font-weight: 500;
        width: calc(100% - 15px);
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    
`;


function NemiciAmiciWrestlerRender({ mostChallenged }) {
    const navigate = useNavigate();

    // Navigazione al wrestler
    const navigateToWrestler = (wrestler) => {
        navigate(`/wrestlers/i_${wrestler.id}_d_${wrestler.name}`);
    }

    // Navigazione al ppv
    const navigateToPpv = (ppv) => {
        navigate(`/ppv/specific/i_${ppv.id}_d_${ppv.name}`);
    }

    const renderChallengerInfo = (challengerInfo, key) => {
        return (
            <ContainerSingleChallengerInfo className='container-single-challenger-info' key={key}>
                <TopDecorColor
                 className='top-decor-color'
                 height='10px'
                />

                <BoxAvatarNameChallenger className='box-avatar-name-challenger'>
                    <h2 className='name-challenger'>{challengerInfo.name}</h2>
                    <img 
                        src={process.env.REACT_APP_STORAGE_URL + challengerInfo.avatar_path} 
                        alt={challengerInfo.name} 
                        className='avatar-challenger'
                        onClick={() => navigateToWrestler(challengerInfo)}
                    />
                </BoxAvatarNameChallenger>

                <ContainerListMatchOpponent className='container-list-match-opponent'>
                    {challengerInfo.fights.map((fight, key) => (
                        <SingleBoxMatchInOpponent 
                         className='single-box-match-in-opponent' 
                         key={key}
                         onClick={() => navigateToPpv(fight.ppv)}
                        >
                            <img 
                                src={process.env.REACT_APP_STORAGE_URL + fight.ppv.img_path} 
                                alt={fight.ppv.name} 
                                className='avatar-match'
                            />
                            <h6 className='name-match'>{fight.ppv.ppv_description.name} {fight.ppv.date.split('-')[2]}</h6>
                        </SingleBoxMatchInOpponent>
                    ))}
                </ContainerListMatchOpponent>
                
            </ContainerSingleChallengerInfo>
        )
    }


    return (
        <GenericRenderContainerSection 
         className='nemici-amici-wrestler-render'
         width="95%"
        >
            <p className='info-section info-nemici-amici'>
                Lista dei wrestler con cui ha condiviso più volte il ring per un match in PPV. Cliccando sul match, si viene indirizzati al PPV.
            </p>

            <ContainerNemiciAmici className='container-nemici-amici'>
                {mostChallenged.map((challengerInfo, key) => (
                    renderChallengerInfo(challengerInfo, key)
                ))}
            </ContainerNemiciAmici>
        </GenericRenderContainerSection>
    )
}

export default NemiciAmiciWrestlerRender;